import apiClient from '../Utils/apiClient';

const NotificationController = {
  list: async (params = {}) => {
    const response = await apiClient.get('notifications', { params });
    return response.data;
  },

  unreadCount: async () => {
    const response = await apiClient.get('notifications/unread-count');
    return response.data;
  },

  markRead: async (id) => {
    const response = await apiClient.post(`notifications/${id}/read`);
    return response.data;
  },

  markAllRead: async () => {
    const response = await apiClient.post('notifications/read-all');
    return response.data;
  },

  manageList: async (params = {}) => {
    const response = await apiClient.get('notifications/manage', { params });
    return response.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('notifications', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`notifications/${id}`, payload);
    return response.data;
  },

  remove: async (id) => {
    const response = await apiClient.delete(`notifications/${id}`);
    return response.data;
  },
};

export default NotificationController;
